import { useLanguageContext } from "../../../context/LanguageContext";
import PrinterPage from "../../../pages/printers/printer/PrinterPage";
import { usePrinterEditRouteValidator } from "../../validators/printers/PrinterEditRouteValidator";
import { RouteConfig } from "../RouteConfig";
import usePrintersRouteConfig from "./PrintersRouteConfig";

/**
 * The route config which contains static information about the route
 * @returns {{ path, label, validator, getPage, getRouteElement }}
 */
function usePrinterEditRouteConfig() {
  const { translate } = useLanguageContext();

  return new RouteConfig()
    .setPath("/dashboard/printers/:printer/edit")
    .setLabel(
      translate("eva.main.entities.states.edit", [
        {
          key: "entities",
          value: translate("eva.main.entities.printer"),
        },
      ])
    )
    .setValidator(usePrinterEditRouteValidator())
    .setPage(<PrinterPage />)
    .setParent(usePrintersRouteConfig());
}

export default usePrinterEditRouteConfig;
